var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.loading
    ? _c("credit-report-table-loader")
    : _c(
        "div",
        [
          _vm.creditReports.length
            ? _c("v-client-table", {
                ref: "additionalCreditReportTable",
                staticClass:
                  "w-100 vue-custom-table no-pagination credit-report-table text-center",
                attrs: {
                  data: _vm.creditReports,
                  columns: _vm.columnsTable,
                  options: _vm.options,
                  name: "additionalCreditReportTable",
                },
                scopedSlots: _vm._u(
                  [
                    {
                      key: "name",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c("p", { staticClass: "mb-0" }, [
                            _vm._v(
                              _vm._s(row.firstName) + " " + _vm._s(row.lastName)
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "dateObtained",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c("p", { staticClass: "mb-0" }, [
                            _vm._v(
                              "\n        " +
                                _vm._s(
                                  _vm._f("formatDateUTCCustom")(
                                    row.dateObtained,
                                    "MMM. DD, YYYY"
                                  )
                                ) +
                                "\n      "
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "status",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          row.status.toLowerCase() === "completed"
                            ? _c(
                                "p",
                                {
                                  staticClass:
                                    "capitalize badge badge-success mb-0",
                                },
                                [
                                  _vm._v(
                                    "\n        " +
                                      _vm._s(_vm.$t("global.words.success")) +
                                      "\n      "
                                  ),
                                ]
                              )
                            : _c(
                                "p",
                                {
                                  staticClass: "capitalize badge badge-danger",
                                },
                                [
                                  _vm._v(
                                    "\n        " +
                                      _vm._s(
                                        _vm._f("capitalize")(
                                          _vm.$t("global.words.failed")
                                        )
                                      ) +
                                      "\n      "
                                  ),
                                ]
                              ),
                        ]
                      },
                    },
                    {
                      key: "type",
                      fn: function (ref) {
                        var row = ref.row
                        return [
                          _c("p", { staticClass: "mb-0" }, [
                            _vm._v(
                              "\n        " +
                                _vm._s(
                                  row.type.includes("Sanctions")
                                    ? _vm.$t(
                                        "direct-to-lender.creditBureau.pepOrSanctions"
                                      )
                                    : row.type.includes("Assist")
                                    ? _vm.$t(
                                        "direct-to-lender.creditBureau.amlAssist"
                                      )
                                    : ""
                                ) +
                                "\n      "
                            ),
                          ]),
                        ]
                      },
                    },
                    {
                      key: "actions",
                      fn: function (ref) {
                        var row = ref.row
                        var index = ref.index
                        return [
                          _c(
                            "button",
                            {
                              staticClass: "btn btn-sm btn-primary",
                              attrs: {
                                disabled:
                                  row.transactionId === null ||
                                  _vm.loadingPreview[index].loading,
                                loading: _vm.loadingPreview[index].loading,
                              },
                              on: {
                                click: function ($event) {
                                  return _vm.handlePreview({
                                    row: row,
                                    index: index,
                                  })
                                },
                              },
                            },
                            [
                              _vm.loadingPreview[index].loading
                                ? [
                                    _c("i", {
                                      staticClass: "fa fa-spinner fa-spin",
                                    }),
                                  ]
                                : [
                                    _vm._v(
                                      "\n          " +
                                        _vm._s(
                                          _vm.$t(
                                            "direct-to-lender.creditBureau.preview"
                                          )
                                        ) +
                                        "\n        "
                                    ),
                                  ],
                            ],
                            2
                          ),
                        ]
                      },
                    },
                  ],
                  null,
                  false,
                  3454610260
                ),
              })
            : _c(
                "no-results",
                {
                  attrs: {
                    "img-src": require("@Shared/@Assets/img/application-missing.png"),
                  },
                },
                [
                  _vm._v(
                    "\n    " +
                      _vm._s(_vm.$t("tables.messages.emptyCreditReports")) +
                      "\n  "
                  ),
                ]
              ),
        ],
        1
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }